import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Hero from './components/Hero';
// import HeroVideo from './components/HeroVideo';
import HeroYouTubeVideo from './components/HeroYouTubeVideo';
import RoomsSection from './components/RoomsSection';
import ReviewsSection from './components/ReviewsSection';
import GallerySection from './components/GallerySection';
import TourPlanSection from './components/TourPlanSection';
import BookingSection from './components/BookingSection';
import MapSection from './components/MapSection';
import LocalSeoSection from './components/LocalSeoSection';
import SeoJsonLd from './components/SeoJsonLd';
import HeadRouteSync from './components/HeadRouteSync';
import Footer from './components/Footer';
import BookPage from './pages/BookPage';
import MenuPage from './pages/MenuPage';
import AccountPage from './pages/AccountPage';

const theme = createTheme({
  palette: {
    primary: { main: '#4a7c59' },
    secondary: { main: '#2c2926' },
  },
  typography: {
    fontFamily: '"DM Sans", -apple-system, BlinkMacSystemFont, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <SeoJsonLd />
          <HeadRouteSync />
          <Header />
          <Routes>
            <Route
              path="/"
              element={
                <main>
                  <Hero />
                  {/* <HeroVideo /> */}
                  <HeroYouTubeVideo />
                  <RoomsSection />
                  <ReviewsSection />
                  <GallerySection />
                  <TourPlanSection />
                  <BookingSection />
                  <LocalSeoSection />
                  <MapSection />
                </main>
              }
            />
            <Route path="/book" element={<BookPage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/account" element={<AccountPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;